export const CREATE_MATERIAL = 'CREATE_MATERIAL'
export const UPDATE_MATERIAL = 'UPDATE_MATERIAL'
export const DELETE_MATERIAL = 'DELETE_MATERIAL'
export const SEARCH_MATERIAL = 'SEARCH_MATERIAL'
export const SET_MATERIAL_SEARCH_CRITERIA = 'SET_MATERIAL_SEARCH_CRITERIA'
export const SET_MATERIAL_DETAILS = 'SET_MATERIAL_DETAILS'
